<template>
    <div>
        <el-form :inline="true" :model="query" class="query-form" size="small">

            <el-form-item>
                <el-button type="primary" icon="el-icon-edit" @click.native="handleInput(null,null)">添加</el-button>
            </el-form-item>

            <el-form-item class="query-form-item">
                <el-input placeholder="品牌名称" v-model="query.brandtitle"  prefix-icon="el-icon-search"
                          @keyup.enter.native="onSubmit"
                          clearable>
                </el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-refresh" @click="onRest"></el-button>
                <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
            </el-form-item>

        </el-form>
        <!-- <el-scrollbar class="table-scrollbar" wrap-style="overflow-x: hidden;"> -->
        <el-table
            ref="multipleTable"
            v-loading="loading"
            :data="list"
            :header-cell-style="{background:'#F4F4F5',color:'#606266'}"
            @selection-change="handleSelectionChange"
            border
        >

            <el-table-column
                v-if="false"
                label="选择"
                prop="orderid"
                type="selection"
                :show-overflow-tooltip="true"
                width="50"
                align="center"
            />
            <el-table-column label="图片" prop="brandurl" align="center" width="200">
                <template slot-scope="scope">
                    <el-popover placement="right" trigger="hover">
                        <img :src="scope.row.brandurl" style="width:400px;border-radius:3px;">
                        <img
                            slot="reference"
                            :src="scope.row.brandurl"
                            style="max-height: 50px;max-width: 50px;border-radius:5px;"
                        >
                    </el-popover>
                </template>
            </el-table-column>
            <el-table-column label="xx品牌" align="center" prop="brandtitle"/>
            <el-table-column label="序列号" align="center" prop="brandsort"/>
            <el-table-column width="200" label="操作" align="center">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" @click.native="handleForm(scope.$index,scope.row)" >修改</el-button>
                    <el-button type="danger"  size="mini" @click.native="handleDel(scope.row.brandid)" >删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="left-container">
            <el-button v-if="false" type="danger" size="small" @click="delGroup()">删除已选</el-button>
            <transition name="el-fade-in-linear">
                <el-button size="small" @click="toggleSelection()" v-show="cancelToggle">取消选择</el-button>
            </transition>
        </div>
        <el-pagination
            class="pagination-container"
            background
            :page-size="query.pageSize"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            layout="total,sizes,prev, pager, next, jumper"
            :page-sizes="[10, 20, 30, 50]"
            :total="totalNumber"
        ></el-pagination>

        <!--增加-->
        <el-dialog
            :visible.sync="formInput"
            :before-close="hideFormAdd"
            width="800px"
            top="5vh"
            v-dialogDrag
        >
            <el-form :model="formData" :rules="formRules" ref="dataForm" >
                <el-form-item label="品牌:" prop="brandtitle" >
                    <el-input v-model="formData.brandtitle" clearable></el-input>
                </el-form-item>

                <el-form-item label="序列号:" prop="brandsort" >
                    <el-input v-model="formData.brandsort" clearable></el-input>
                </el-form-item>

                <el-form-item label="图片:" prop="brandurl">
                    <el-upload
                        v-show="pic_is_show"
                        class="avatar-uploader"
                        style="margin-bottom: 15px;"
                        accept=".png, .jpg, .gif, .jpeg, .bmp"
                        :action="uploadUrl"
                        :headers="{'hfmauth':'VOB1O/NchSeZ8YFJHVdAzRvZhjZSkJeg'}"
                        :show-file-list="false"
                        :on-success="handleAvatarSuccess"
                    >
                        <img v-if="formData.brandurl" :src="formData.brandurl" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">

                <el-button @click.native="hideFormInput">取消</el-button>
                <el-button type="primary" @click.native="formSub()" :loading="formLoading">保存</el-button>
            </div>
        </el-dialog>

        <!--修改-->
        <el-dialog
            :visible.sync="formVisible"
            :before-close="hideForm"
            width="800px"
            top="5vh"
            v-dialogDrag
        >
            <el-form :model="formData" :rules="formRules" ref="dataForm" >
                <el-form-item label="品牌:" prop="brandtitle" >
                    <el-input v-model="formData.brandtitle" clearable></el-input>
                </el-form-item>

                <el-form-item label="序列号:" prop="brandsort" >
                    <el-input v-model="formData.brandsort" clearable></el-input>
                </el-form-item>

                <el-form-item label="图片:" prop="brandurl">
                    <el-upload
                        v-show="pic_is_show"
                        class="avatar-uploader"
                        style="margin-bottom: 15px;"
                        accept=".png, .jpg, .gif, .jpeg, .bmp"
                        :action="uploadUrl"
                        :headers="{'hfmauth':'VOB1O/NchSeZ8YFJHVdAzRvZhjZSkJeg'}"
                        :show-file-list="false"
                        :on-success="handleAvatarSuccess"
                    >
                        <img v-if="formData.brandurl" :src="formData.brandurl" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">

                <el-button @click.native="hideForm">取消</el-button>
                <el-button type="primary" @click.native="formSubmit()" :loading="formLoading">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getList,deleteBrand,addBrand,updateBrand} from "../../api/product/brand2.js";
import {BASE_URL} from "../../config/app";
const formJson = {
    brandid:"",
    brandurl:"",
    brandtitle:"",
    brandsort:""
};

export default {
    data() {
        var checkTitle = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('请输入品牌'));
            } else {
                callback();
            }
        };
        var checkSort= (rule, value, callback) =>{
            if (!value) {
                return callback(new Error('请输入序列号'));
            } else {
                var reg = /^[0-9]*$/;
                if (reg.test(value)) {
                    callback();
                } else {
                    return callback(new Error('请输入正整数'));
                }
            }
        };
        var checkUrl= (rule, value, callback) =>{
            if (!value) {
                return callback(new Error('请上传封面图'));
            } else {
                callback();
            }
        };

        return {
            moneyreward:"",
            ordercategory:"",
            dialogImageUrl: '',
            dialogVisible: false,
            cancelToggle:false,
            servicestarttime: [],
            query: {
                brandtitle:"",
                currentPage: 1,
                pageSize: 10
            },
            list: [],
            totalNumber: 0,
            loading: true,
            index: null,
            formName: null,
            formLoading: false,
            formVisible: false,
            formInfo:false,
            formInput:false,
            formData: formJson,
            formRules: {
                brandtitle: [{ validator: checkTitle, trigger: "blur" }],
                brandsort: [{ validator: checkSort, trigger: "blur" }],
                brandurl: [{ validator: checkUrl, trigger: "blur" }],
            },
            uploadUrl: BASE_URL + "/upload/tool/uploadpro",
            pic_is_show: true,
            multipleSelection: [] //多选集合
        };
    },
    methods: {

        handleRemove(file, fileList) {
            console.log(file, fileList);
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        dateChange(val) {
            if (val == null) {
                this.query.startTime = "";
                this.query.endTime = "";
            } else {
                this.query.startTime = val[0];
                this.query.endTime = val[1];
            }
            this.getList();
        },
        toggleSelection(rows) {
            if (rows) {
                rows.forEach(row => {
                    this.$refs.multipleTable.toggleRowSelection(row);
                });
            } else {
                this.$refs.multipleTable.clearSelection();
            }
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
            if (val == "") {
                this.cancelToggle = false;
                return;
            }
            this.cancelToggle = true;
        },
        delGroup() {
            var ids = this.multipleSelection.map(item => item.brandid).join(); //获取所有选中行的id组成的字符串，以逗号分隔
            if (ids == "") {
                this.$message({
                    message: "请先选择",
                    type: "warning"
                });
                return;
            }
            this.handleDel(ids);
        },
        onRest() {
            this.$router.push({
                path: ""
            });
            this.query = {

                currentPage: 1,
                pageSize: 10
            };
            this.msgtime = [];
            this.getList();
        },
        onSubmit() {
            this.$router.push({
                path: "",
                query: this.query
            });
            this.getList();
        },
        handleCurrentChange(val) {
            this.query.currentPage = val;
            //scrollTo(0, 800);
            this.getList();
        },
        handleSizeChange(val) {
            this.query.pageSize = val;
            this.getList();
        },
        handleAvatarSuccess(res, file) {
            this.formData.brandurl = res.data;
            console.info(res);
            console.info(file);
        },
        getList() {
            this.loading = true;
            getList(this.query)
                .then(response => {
                    if (response.code) {
                        this.$message.error(response.message);
                    }

                    this.list = response.data.list || [];
                    this.totalNumber = response.data.totalNumber || 0;
                    setTimeout(() => {
                        this.loading = false;
                    }, 0.3 * 1000);
                })
                .catch(() => {
                    this.loading = false;
                    this.list = [];
                    this.totalNumber = 0;
                });
        },
        // 隐藏表单
        hideForm() {
            // 更改值
            this.formVisible = !this.formVisible;
            return true;
        },
        hideFormAdd() {
            // 更改值
            this.formInput = !this.formInput;
            return true;
        },

        hideFormInput() {
            // 更改值
            this.formInput = !this.formInput;
            return true;
        },

        hideInfo() {
            // 更改值
            this.formInfo = !this.formInfo;
            // 清空表单
            this.$refs["dataForm"].resetFields();
            this.$refs.tinymce.clearContent();
            this.query.brandtitle="";
            return true;
        },
        hideInput() {
            // 更改值
            this.formInput = !this.formInput;
            // 清空表单
            this.$refs["dataForm"].resetFields();
            this.query.brandtitle="";
            return true;
        },
        // 显示表单
        handleForm(index, row){
            this.formVisible = true;
            this.formData = Object.assign({}, formJson);
            if (row !== null) {
                this.formData = Object.assign({}, row);
            }
            // 清空验证信息表单
            if (this.$refs["dataForm"]) {
                this.$refs["dataForm"].clearValidate();
            }

        },

        handleInput(index, row){
            this.formInput = true;
            this.formData = Object.assign({}, formJson);
            if (row !== null) {
                this.formData = Object.assign({}, row);
            }
            //编辑
            if (index !== null) {
                this.index = index;
                let vm = this;
                setTimeout(function() {
                    vm.$nextTick(() => {
                        if (vm.$refs.tinymce) {
                            vm.$refs.tinymce.setContent(
                                vm.formData.problemanswer
                            );
                        }
                    });
                }, 350);
            }
            // 清空验证信息表单
            if (this.$refs["dataForm"]) {
                this.$refs["dataForm"].clearValidate();
            }
        },

        formSubmit(){
            this.$refs["dataForm"].validate(valid => {
                if (valid) {
                    this.formLoading = true;
                    this.formData.msgtime = "";
                    let data = Object.assign({}, this.formData);
                    console.log(data);
                    console.log(data.msgid)
                    updateBrand(data).then(response => {
                        this.formLoading = false;
                        if (response.code) {
                            this.$message.error(response.message);
                            return false;
                        }
                        this.$message.success("操作成功");
                        // 刷新表单
                        this.$refs["dataForm"].resetFields();
                        //this.$refs.tinymce.clearContent();
                        this.formVisible = false;
                        this.query.brandtitle = "";
                        this.getList();
                    });

                }
            });
        },

        formSub() {
            this.$refs["dataForm"].validate(valid => {
                if (valid) {
                    this.formLoading = true;
                    let data = Object.assign({}, this.formData);
                    console.log(data);
                    addBrand(data).then(response => {
                        this.formLoading = false;
                        if (response.code) {
                            this.$message.error(response.message);
                            return false;
                        }
                        this.$message.success("操作成功");
                        // 刷新表单
                        //this.$refs["dataForm"].resetFields();
                        //this.$refs.tinymce.clearContent();
                        this.formInput = false;
                        this.query.brandtitle = "";
                        this.getList();
                    });
                }
            });
        },
        // 删除
        handleDel(ids) {
            if (ids) {
                this.$confirm("确认要删除吗?", "提示", {
                    type: "warning"
                })
                    .then(() => {
                        this.loading = true;
                        var params = new URLSearchParams();
                        params.append("ids", ids);
                        deleteBrand(params)
                            .then(response => {
                                this.loading = false;
                                if (response.code) {
                                    this.$message.error(response.message);
                                    return false;
                                }
                                this.$message.success("删除成功");
                                // 刷新数据
                                //this.list.splice(index, 1);
                                this.getList();
                            })
                            .catch(() => {
                                this.loading = false;
                            });
                    })
                    .catch(() => {});
            }
        }
    },
    created() {
        // 将参数拷贝进查询对象
        let query = this.$route.query;
        this.query = Object.assign(this.query, query);
        this.query.pageSize = parseInt(this.query.pageSize);
        // 加载表格数据
        this.getList();
    }
};
</script>

<style type="text/scss" lang="scss">
body {
    margin: 0;
}
.app_logo {
    width: 150px;
    height: 150px;
    border-radius: 5px;
    max-width: 150px;
    max-height: 150px;
}
.loading_div {
    width: 150px;
    height: 150px;
    border-radius: 5px;
    max-width: 150px;
    max-height: 150px;
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px !important;
    text-align: center;
}
.avatar {
    width: 178px;
    height: 178px;
    display: block;
}


</style>
